import { cloneElement } from 'react'

import { useWindowSize } from '@uidotdev/usehooks'
import { Link } from 'react-router-dom'

import ChristmasLine from '@/assets/images/christmas/line-long.png'
import { PageHeader } from '@/components/layout/page/page-header'
import { Button } from '@/components/ui/button'
import { Tabs } from '@/components/ui/tabs'
import { EndTrialSection } from '@/modules/licenses/components/end-trial'
import { LicenseMode } from '@/modules/licenses/types'
import { AppRoutes } from '@/utils/constants'
import { classNames } from '@/utils/helpers'

import type { CampaignLicensesPageProps } from '../types'
import { christmasBackgroundByWindowSize } from './consts'

type WindowSizes = keyof typeof christmasBackgroundByWindowSize

export const ChristmasOfferLicensesPage = ({
  tabsContent,
  tabsList,
}: CampaignLicensesPageProps) => {
  const { width } = useWindowSize()

  const christmasHeader =
    christmasBackgroundByWindowSize[
      (Object.keys(christmasBackgroundByWindowSize)
        .map(Number)
        .sort((a, b) => b - a)
        .find((key) => (width ?? 0) > key) ?? 0) as WindowSizes
    ]

  return (
    <Tabs defaultValue={LicenseMode.MONTHLY}>
      <div className="relative -mx-4 mb-[18px] overflow-hidden bg-[linear-gradient(91deg,#E3262F_0%,#ED8388_100%)] pt-[18px] dark:bg-[linear-gradient(90deg,#0C0D11_0%,#0F0662_100%)] lg:-mx-[27px] lg:rounded-2xl">
        <div className="relative z-10">
          <div className="space-y-8 px-[27px] pb-[220px] pt-[18px] min-[750px]:pb-[29px]">
            <div>
              <PageHeader
                title="Licenses"
                titleClassName="text-white"
                description={
                  <span className="text-white">
                    Get a License to connect a creator with CreatorHero
                  </span>
                }
                className="mb-4 min-[750px]:flex-row min-[750px]:justify-between"
                optionComponents={
                  <Link
                    to={AppRoutes.Licenses.YourLicenses.asUrl()}
                    className="truncate"
                  >
                    <Button>Your Licenses</Button>
                  </Link>
                }
              />
              <EndTrialSection />
            </div>
            {tabsList}
          </div>
          <div
            className="h-1.5 w-full bg-cover bg-center bg-repeat-x"
            style={{ backgroundImage: `url('${ChristmasLine}')` }}
          />
        </div>
        {cloneElement(christmasHeader, {
          className: classNames(
            'absolute left-1/2 top-1/2 z-0 -translate-y-1/2',
            christmasHeader.props.className,
          ),
        })}
      </div>
      {tabsContent}
    </Tabs>
  )
}
